import React from "react";
import { useReducer } from "react";

import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from 'recharts';

import Input from "./Input";
import CheckBox from "./CheckBox";

import {
  reducer,
  pluralize,
  formatted_currency,
  initial_state as init,
  GRAPH_COLOR,
} from './lib.js';

const App = () => {
  const [state, dispatch] = useReducer(reducer, init);

  const onChange = (domEvent) => {
    const {target} = domEvent;
    const {value, name, type, checked} = target;

    let input = value;

    if (type == 'checkbox') {
      input = !checked;
    }

    dispatch({ type: name, value: input });
  }

  const recalculate = (evt) => {
    if(evt.type === 'submit' || evt.type === 'reset') {
      evt.preventDefault();
    }

    if(evt.type === 'reset') {
      dispatch({ type: 'reset', value: init });
    } else {
      const input = 0;
      dispatch({ type: 'recalculate', value: input });
    }
  }

  return (
    <>
    <form onSubmit={recalculate} onChange={recalculate} onReset={recalculate}>
      <p>
        <Input
          type="text"
          name="principal"
          inputMode="decimal"
          labelText="Starting principal"
          onChange={onChange}
          onBlur={onChange}
          size={10}
          value={state.principal}
        />
      </p>

      <p>
        <Input
          type="number"
          name="rate"
          inputMode="decimal"
          step={0.001}
          labelText="Interest rate "
          size={9}
          min={0}
          value={state.rate}
          onChange={onChange}
          onBlur={onChange}
        /><span title="percent">%</span>
      </p>

      <p>
        <Input
          type="number"
          name="years"
          step={1}
          labelText="Number of years"
          size={9}
          min={1}
          value={state.years}
          onChange={onChange}
          onBlur={onChange}
        />
      </p>

      <p>
        <CheckBox
          name="monthly"
          labelText="Compound monthly?"
          onChange={onChange}
          checked={ state.monthly }
        />
      </p>

      <div>
        <button type="submit">Calculate</button>
        <button type="reset">Reset data</button>
      </div>

       <p>
        <output
          htmlFor="principal rate"
          name="years"
        >In <strong>{state.years} {pluralize(state.years)}</strong> at a <strong>{state.rate}% annual rate,</strong> you&#8217;ll have <strong>{state.balance}.</strong></output>
      </p>
    </form>

    <div hidden={!state.chart.length}>
      <ResponsiveContainer>
        <AreaChart
          width={500}
          height={300}
          data={state.chart}
          margin={{
            top: 5,
            right: 10,
            left: 10,
            bottom: 5,
          }}
        >
        <defs>
          <linearGradient id="interest" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor={GRAPH_COLOR} stopOpacity={0.8}/>
            <stop offset="95%" stopColor={GRAPH_COLOR} stopOpacity={0}/>
          </linearGradient>
        </defs>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis dataKey="amount" domain={[state.principal, 'auto']} />
          <Tooltip
            separator=': '
            formatter={(el) => [formatted_currency(el), 'Balance']}
          />
          <Area type="monotone"
            dataKey="amount"
            stroke={GRAPH_COLOR}
            fillOpacity={1}
            fill="url(#interest)"
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
    </>
  )
}

export default App;